export const MODAL_TITLE = 'Identify manufacturers';
